import DadosPessoais from "./DadosPessoais";
import DadosProfissionais from "./DadosProfissionais";
import DadosContato from "./DadosContato/DadosContato";
import DadosEndereco from "./DadosEndereco";
import DadosCondicoesGerais from "./DadosCondicoesGerais";
import Form from "components/Form";
import { useAppContext } from "contexts/AppContext";
import { useNavigate } from "react-router-dom";
import useCotacao from "hooks/useCotacao";
import useProposta from "hooks/useProposta";
import { useState } from "react";
import PldErrorModal from "components/PldErrorModal";

const initialData = {
  dadosPessoais: { nome: "", nomeSocial: "", cpf: "", dataNascimento: "", sexo: "" },
  dadosProfissionais: {
    profissao: { id: "", value: "" },
    renda: { id: "", value: "" },
  },
  dadosContato: {
    celular: "",
    telefone: "",
    email: "",
    receberNovidades: "",
  },
  dadosEndereco: {
    cep: "",
    dadosComplementares: {
      endereco: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      uf: { id: "", value: "" },
    },
  },
};

const FormDados = () => {
  const {
    personalData = initialData,
    setPersonalData,
    setProposta,
    setGlobalError,
  } = useAppContext();
  const [bloqueioVenda, setBloqueioVenda] = useState("");
  const [loading, setLoading] = useState(false);
  const { salvarCotacao } = useCotacao();
  const { salvarProposta } = useProposta();
  const navigate = useNavigate();

  const handleSubmit = async (_personalData) => {
    setLoading(true);
    const cotacaoResult = await salvarCotacao(_personalData);
    if (cotacaoResult?.type === "error") {
      setLoading(false);
      return;
    }
    const codigoCotacao = cotacaoResult?.data?.[0]?.identificacao?.codigo;
    const propostaResult = await salvarProposta(codigoCotacao);

    if (
      propostaResult?.error?.response?.data?.moreInformation?.includes("[001]")
    ) {
      setBloqueioVenda("total");
      setLoading(false);
      return;
    }

    if (
      propostaResult?.error?.response?.data?.moreInformation?.includes("[002]")
    ) {
      setBloqueioVenda("parcial");
      setLoading(false);
      return;
    }

    if (!propostaResult?.data?.identificacao?.codigoNegocio) {
      setGlobalError({});
      setLoading(false);
      return;
    }

    setLoading(false);

    setPersonalData(_personalData);
    setProposta(propostaResult?.data);
    navigate("/unico/pagamento");
  };
  return (
    <Form onSubmit={handleSubmit} scheme={personalData}>
      <DadosPessoais name="dadosPessoais" />
      <DadosProfissionais name="dadosProfissionais" />
      <DadosContato name="dadosContato" />
      <DadosEndereco name="dadosEndereco" />
      <DadosCondicoesGerais loading={loading} />
      <PldErrorModal
        onClose={() => setBloqueioVenda("")}
        bloqueio={bloqueioVenda}
      />
    </Form>
  );
};

export default FormDados;
